import { render } from "./JudgeDetailTestCase.vue?vue&type=template&id=0947eff3&scoped=true&ts=true"
import script from "./JudgeDetailTestCase.vue?vue&type=script&lang=ts"
export * from "./JudgeDetailTestCase.vue?vue&type=script&lang=ts"

import "./JudgeDetailTestCase.vue?vue&type=style&index=0&id=0947eff3&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0947eff3"]])

export default __exports__